import React from "react";
import styled from 'styled-components';
import puzzlepic from '../pictures/puzzle.jpg';

class Puzzle extends React.Component {
render(){
    const WORKCOVER = styled.div`
        width: 100%;
        height: 100%;
    `;

    const TITLE = styled.h1`
        margin: 0;
        padding-top: calc(30px + 8vw);
        padding-bottom: 3vh;
        text-align: center;
        color: black;
    `;

    const BOX = styled.div`
    `;

    const IMG = styled.img`
        width: 35%;
        height: 100%;
        display: block;
        margin: 0 auto;
        `;

    const CONTENT = styled.div`
        padding: 3em;
    `;

    const TECH = styled.div`
        margin-bottom: 3em;
        color: black;
        font-size:calc(10px + 0.4vw)
    `;

    const BUTTONS = styled.div`
        display: flex;
        justify-content: space-around;
        text-align:center;
        vertical-align: middle;
    `;
    const BUTTON = styled.a`
        width: calc(40px + 4vw);
        height: calc(20px + 2.5vw);
        line-height: calc(20px + 2.5vw);
        margin: 1em;
        padding: 0.23em 0.5em;
        font-size:calc(10px + 0.4vw)
        font-weight: bold;
        color: white;
        border-style: none;
        border-radius: 3px;
        text-decoration: none;
        background-color: #0F4137;
    `;

return(
<div>
<WORKCOVER>
    <TITLE>数字パズル</TITLE>
    <BOX>
        <IMG src= {puzzlepic} alt=""/>
        <CONTENT>
            <TECH>
            使用技術：<br/>
            HTML/jQuery/JavaScript<br/><br/>
            詳細：<br/>
            白マスをタッチすると隣のマスと入れ替わります。<br/>
            左上から、白マス→1→8順番に並ぶように入れ替えてください<br/>
            最初の数字パズルをクリアするとレベル2の曜日パズルに進めます。
            </TECH>
            <BUTTONS>
                <BUTTON href="https://yukiamakawa.github.io/puzzle3x3-eng-level2/puzzle3x3-eng-level2.html" target="_blank">
                    デモ
                </BUTTON>
                <BUTTON href = "https://github.com/YukiAmakawa/puzzle3x3-eng-level2" target="_blank">
                    GitHub
                </BUTTON>
            </BUTTONS>
        </CONTENT>
    </BOX>
</WORKCOVER>
</div>
)}}

export default Puzzle;


// WEBPACK FOOTER //
// ./src/components/Puzzle.js